// extracted by mini-css-extract-plugin
export var cardIcon = "_a9-4";
export var checkboxCard = "_a9-0";
export var checkboxCardSelected = "_a9-1";
export var disabled = "_a9-2";
export var outerBorder = "_a9-3";
export var spacerMedium = "_a9-7";
export var spacerSmall = "_a9-6";
export var spacerXsmall = "_a9-5";